import script from "./Attendance.vue?vue&type=script&setup=true&lang=js"
export * from "./Attendance.vue?vue&type=script&setup=true&lang=js"

import "./Attendance.vue?vue&type=style&index=0&id=555feb9b&lang=css"

const __exports__ = script;

export default __exports__